import jsPDF from "jspdf";
import dayjs from "dayjs";
import laiSenBale from "./pic/a2.jpg";
import arabicToThai from "../../../../hook/arabicToThai";

export async function exportNotifyGuarantor3NNew(
    dataTabelB,
    selectedContract,
    countBatch,
    targetWindow
) {

    const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();

    const doc = new jsPDF('p', 'mm', 'a4');

    dataTabelB.forEach((item, index) => {
        if (index > 0) doc.addPage();

        let y = 20; // ตำแหน่ง Y เริ่มต้น
        const lineHeight = 8; // ระยะห่างบรรทัด (สำคัญเพื่อให้ดูเหมือนเอกสารจริง)

        doc.setFont('THSarabunNew', 'normal');
        doc.setFontSize(14);

        // --- ส่วนหัว (ชื่อบริษัทและที่อยู่) ---
        doc.setFont('THSarabunNew', 'normal');


        const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1} 
                                    ต.${item?.TUMB} อ.${item?.AUMPDES} จ.${item?.PROVDES} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.RoundDate).format('DD/MM/YYYY')})
        `;
        doc.text(address, 5, y);
        y += 67;

        // --- วันที่ ---
        const dataNow = dayjs(item.RoundDate).format('DD/MM/YYYY'); // เปลี่ยนเป็นวันที่ยึด

        doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
        y += 10;


        const s1 = `
        เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        `;
        doc.text(s1, 5, y);
        y += 7;

        const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2} 
        `;
        doc.text(s2, 5, y);
        y += 22;

        // --- เนื้อหา Paragraph 1 ---
        doc.setFont('THSarabunNew', 'normal');

        doc.text(`ตามที่ท่านผู้กู้ได้ตกลงทำสัญญากู้ยืมเงินจำนวน`, 25, y);
        doc.setFont("THSarabunNew", "bold");

        const tcarcst = Number(item?.TCARCST ?? 0).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        // const amount = Number(item.EXP_AMT) || 0;
        const tcarcstThaiText = numberToThaiText(tcarcst);

        doc.text(`${tcarcst} บาท (${tcarcstThaiText})`, 90, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text('ไปจากบริษัท', 165, y);

        y += lineHeight;

        // doc.setFont('THSarabunNew', 'normal');
        doc.text('วัน มันนี่ จำกัด (สำนักงานใหญ่) ตามสัญญากู้ยืมเงิน ลงวันที่', 15, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${dayjs(item.SDATE).format('DD/MM/YYYY')}`, 95, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text('โดยผู้กู้ได้รับเงินไปครบถ้วนแล้วและได้สมุคคู่มือ', 120, y);

        y += lineHeight;

        doc.text(`จดทะเบียนรถยนต์ ยี่ห้อ `, 15, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item.TYPE}`, 50, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`เลขตัวถัง`, 75, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item.STRNO}`, 90, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`เลขเครื่อง `, 135, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item.ENGNO}`, 155, y);

        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`ทะเบียน`, 15, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item.REGNO} ${item.DORECV}`, 30, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`สี`, 65, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item.COLOR}`, 70, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`มามอบให้ผู้ให้กู้ เพื่อยึดถือไว้เป็นประกันหนี้ตามสัญญากูยืมเงิน`, 110, y);

        y += lineHeight;


        doc.text(`และท่านได้ทำสัญญาค้ำประกันหนี้ดังกล่าว รายละเอียดท่านทราบแจ้งชัดดีอยู่แล้วนั้น`, 15, y);

        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`บัดนี้ ผู้กู้ได้ผิดนัดและค้างชำระหนี้ค่างวดที่  ${item.EXP_FRM + ' - ' + item.EXP_TO}  ซึ่งกำหนดชำระ`, 25, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')}`, 118, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`จำนวน ${item.EXP_PRD} งวดติดต่อกันเป็นจำนวนเงิน`, 138, y);

        y += lineHeight;

        // const amount = Number(item.EXP_AMT) || 0;
        const amount = Number(item?.EXP_AMT ?? 0).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        const amountThaiText = numberToThaiText(amount);

        doc.setFont("THSarabunNew", "bold");
        doc.text(`${amount} บาท     (${amountThaiText})`, 15, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`ผู้ให้กู้จึงแจ้งมายังท่านเพื่อให้ชำระหนี้ที่ผู้กู้ค้างชำระ`, 115, y);

        y += lineHeight;

        doc.text(`พร้อมดอกเบี้ย เบี้ยปรับ และค่าใช้จ่ายทั้งหมดให้แล้วเสร็จภายใน   7  วัน  นับตังแต่วันที่ท่านได้รับหนังสือฉบับนี้`, 15, y);

        y += lineHeight;
        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้กู้มีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`, 15, y);


        y += lineHeight;
        y += lineHeight;


        doc.text(`จึงเรียนมาเพื่อโปรดดำเนินการด่วน`, 30, y);




        // y += 14;

        // --- ส่วนลงนาม (จัดชิดขวา) ---
        // doc.text('ขอแสดงความนับถือ', 130, y,);
        y += 20; // เว้นระยะสำหรับลายเซ็น

        const signatureImg = laiSenBale;  // ใส่ Base64 ของรูปคุณ

        // const offset = 10;
        doc.addImage(signatureImg, 'PNG', 155, 223, 30, 15);

        doc.text('ลงชื่อ....................................', 150, y);
        y += 7;
        doc.text('ผู้ออกจดหมาย', 159, y);

        y += lineHeight;
        y += lineHeight;
        y += lineHeight;
        // y += lineHeight;

        doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
        // y += 7;

        // doc.autoPrint();
        // window.open(doc.output('bloburl'));
    });
    // ฝังคำสั่ง print ลงใน PDF

    doc.autoPrint();
    return doc.output("bloburl");

}